
import Vue from "vue";
export default Vue.extend({
  model: {
    prop: "inputValue",
    event: "change"
  },
  props: {
    label: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    },
    value: {
      default: undefined
    },
    inputValue: {
      default: undefined
    },
    readonly: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: undefined
    }
  },
  methods: {
    onChange(value: any) {
      this.$emit("change", value);
    }
  }
});
